const eventSchedulingType = { MANUAL: 'manual', AUTOMATIC: 'automatic' };

export const eventSchedulingTypeTranslate = { manual: 'Manuel', automatic: 'Automatisk' };

export default eventSchedulingType;
